module.exports = __webpack_public_path__ + "img/speaker_4.b4297748.png";